angular.module('portal.i18n').constant('DefaultLanguage', 'en');
